package ui.new_ui.components.card_handler

import emotion.react.css
import react.FC
import react.PropsWithChildren
import react.dom.html.ReactHTML
import web.cssom.Display
import web.cssom.None
import web.cssom.px
import web.cssom.vh

external interface CardHandlerProps : PropsWithChildren

val CardHandler = FC<CardHandlerProps> {props->
    ReactHTML.ul{
        css {
            listStyle = None.none
            display = Display.grid
            gap = 8.px
            marginTop = 1.vh
        }

        +props.children
    }
}